


































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { TYPES } from '@/constants/booking';
import BookingCreateCandidateTable from '@/components/Booking/BookingCreateCandidateTable.vue';
import BookingCreateFinalise from '@/components/Booking/BookingCreateFinalise.vue';
import RiskProfileSelect from '@/components/RiskProfile/RiskProfileSelect.vue';
import { BOOKING_PURPOSES } from '@/constants/booking';

@Component({
  components: {
    RiskProfileSelect,
    BookingCreateCandidateTable,
    BookingCreateFinalise,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
    ...mapState('ServiceItem', {
      serviceItems: 'serviceItems',
    }),
    ...mapState('BusinessTag', {
      tagList: 'list',
    }),
  },
})
export default class BookingCreate extends Vue {
  // Business State
  business!: Model;

  // Booking State
  booking!: Booking;

  serviceItems!: Model[];
  tagList!: Model[];

  // Data
  showDialog = false;
  currentStep = 0;
  types = TYPES;
  isApiFetch = {
    isApiFetchBusinessFinished: false,
    isApiFetchServiceItemsFinished: false,
    isApiFetchRiskProfileFinished: false,
  };
  isMounted = false;
  purposes = BOOKING_PURPOSES;

  // Computed
  get steps() {
    const step1 = {
      title: 'Step 1',
      subtitle: 'Please select a Quescreen booking option',
      slug: 'booking-purpose',
      canProceed: () => {
        return this.booking.purpose;
      },
    };

    const step2 = {
      title: 'Step 2',
      subtitle: 'Select a risk profile',
      slug: 'risk-profile',
      canProceed: () => {
        return this.booking.risk_profile_oid;
      },
    };

    const steps: any = [step1];

    if (!this.$route.query?.riskProfileOid) {
      steps.push(step2);

      switch (this.booking.type) {
        case this.types.CANDIDATE_PAY:
          steps.push({
            title: 'Step 3',
            slug: 'finalise',
            subtitle: 'Finalise',
          });
          break;
        case this.types.BUSINESS_PAY:
          steps.push(
            {
              title: 'Step 3',
              slug: 'booking-candidates',
              subtitle: 'Quescreen Bookings',
            },
            {
              title: 'Step 4',
              slug: 'finalise',
              subtitle: 'Finalise',
            }
          );
          break;
      }
    } else {
      switch (this.booking.type) {
        case this.types.CANDIDATE_PAY:
          steps.push({
            title: 'Step 2',
            slug: 'finalise',
            subtitle: 'Finalise',
          });
          break;
        case this.types.BUSINESS_PAY:
          steps.push(
            {
              title: 'Step 2',
              slug: 'booking-candidates',
              subtitle: 'Quescreen Bookings',
            },
            {
              title: 'Step 3',
              slug: 'finalise',
              subtitle: 'Finalise',
            }
          );
          break;
      }
    }

    return steps;
  }

  get bookingVal() {
    return this.booking;
  }
  set bookingVal(v) {
    this.$store.commit('Booking/SET_STATE', { key: 'booking', payload: v });
  }

  async created() {
    this.resetState();
    this.bookingVal.risk_profile_oid =
      (this.$route.query?.riskProfileOid as string) || '';
    // this.currentStep = parseInt(this.$route.query?.step as string) || 0
    await this.init();
  }

  mounted() {
    this.bookingVal.business_oid = this.business.object_id;
  }

  beforeDestroy() {
    this.resetState();
  }

  // Watch
  @Watch('booking.candidate_number')
  async candidateNumberChanged() {
    const bookingCandidateCount = this.booking.booking_candidates?.length || 0;
    if (this.booking.candidate_number > bookingCandidateCount) {
      this.booking.booking_candidates?.push({
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        date_of_birth: '',
        additional_services: [],
        source: '',
        tag: null,
      });
    } else if (this.booking.candidate_number < bookingCandidateCount) {
      this.booking.booking_candidates?.pop();
    }
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.isMounted = true;
      }
    }
  }

  init() {
    this.$store
      .dispatch('Business/fetch', {
        businessOid: this.business.object_id,
      })
      .then(() => {
        this.isApiFetch['isApiFetchBusinessFinished'] = true;
      });

    this.isApiFetch['isApiFetchServiceItemsFinished'] = !!this.serviceItems
      .length;
    if (!this.serviceItems.length) {
      this.$store.dispatch('ServiceItem/fetchList').finally(() => {
        this.isApiFetch['isApiFetchServiceItemsFinished'] = true;
      });
    }

    if (this.$route.query?.step || this.$route.query?.riskProfileOid) {
      this.$store
        .dispatch(
          'RiskProfile/fetchFullStructure',
          this.bookingVal.risk_profile_oid
        )
        .then(() => {
          this.isApiFetch['isApiFetchRiskProfileFinished'] = true;
        });
    } else {
      this.isApiFetch['isApiFetchRiskProfileFinished'] = true;
    }

    if (!this.tagList.length) {
      this.$store.dispatch('BusinessTag/fetchList', {
        params: {
          business_oid: this.business.object_id,
        },
      });
    }
  }

  create() {
    this.$store
      .dispatch('Booking/create', {
        ...this.booking,
      })
      .then((response) => {
        this.$router.push({
          name: 'business-booking-read',
          params: {
            bookingOid: response.data.data.object_id,
          },
        });
      });
  }

  get showSubmitSlot() {
    return (
      (this.booking.type === this.types.BUSINESS_PAY &&
        this.$route.query?.riskProfileOid &&
        this.currentStep === 2) ||
      (this.booking.type === this.types.BUSINESS_PAY &&
        !this.$route.query?.riskProfileOid &&
        this.currentStep === 3) ||
      (this.booking.type === this.types.CANDIDATE_PAY && this.currentStep === 2)
    );
  }

  resetState() {
    this.$store.commit('Booking/RESET_STATE');
    this.$store.commit('BusinessTag/RESET_STATE');
    this.$store.commit('RiskProfile/CLEAR_STATE');
  }

  handleFinalise() {
    if (
      this.booking.purpose ===
      this.purposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    ) {
      this.showDialog = true;
    } else {
      this.create();
    }
  }
}
